import type { ProductWarehouseFormValues } from "./schemas"

import { LeadTimeUnits, type ProductWarehouseArea, type ProductWarehouseInput } from "@/graphql/codegen/graphql"
import { calculateLeadTimeDisplayValue, calculateLeadTimeInDays } from "@/screens/Products/utils"

export const toProductWarehouseFormValues = (
  warehouseArea: ProductWarehouseArea | null
): ProductWarehouseFormValues => {
  const leadTimeUnit = warehouseArea?.leadTimeDisplayUnits ?? LeadTimeUnits.Days

  return {
    warehouseAreaId: warehouseArea?.warehouseAreaId ?? "",
    isActive: warehouseArea?.isActive ?? true,
    safetyStock: warehouseArea?.minimumQuantity ?? null,
    stockType: warehouseArea?.stockType ?? null,
    hasCombinedPricing: warehouseArea ? !warehouseArea.excludedFromCombinedPricing : false,
    isOnAllocation: warehouseArea?.isOnAllocation ?? false,
    weightPerTruckload: warehouseArea?.weightPerTruckload ?? null,
    leadTime: warehouseArea ? calculateLeadTimeDisplayValue(warehouseArea.leadTimeInDays, leadTimeUnit) : null,
    leadTimeUnit,
    minOrderQuantity: warehouseArea?.minOrderQuantity ?? null,
  }
}

export const toProductWarehouseInput = (formValues: ProductWarehouseFormValues): ProductWarehouseInput => ({
  warehouseAreaId: formValues.warehouseAreaId,
  isActive: formValues.isActive,
  minimumQuantity: formValues.safetyStock,
  stockType: formValues.stockType,
  excludedFromCombinedPricing: !formValues.hasCombinedPricing,
  isOnAllocation: formValues.isOnAllocation,
  weightPerTruckload: formValues.weightPerTruckload,
  leadTimeInDays: formValues.leadTime ? calculateLeadTimeInDays(formValues.leadTime, formValues.leadTimeUnit) : null,
  leadTimeDisplayUnits: formValues.leadTime ? formValues.leadTimeUnit : null,
  minOrderQuantity: formValues.minOrderQuantity,
})

export const toExistintProductWarehouseInput = (warehouseArea: ProductWarehouseArea): ProductWarehouseInput => ({
  warehouseAreaId: warehouseArea.warehouseAreaId,
  isActive: warehouseArea.isActive,
  minimumQuantity: warehouseArea.minimumQuantity,
  stockType: warehouseArea.stockType,
  excludedFromCombinedPricing: warehouseArea.excludedFromCombinedPricing,
  isOnAllocation: warehouseArea.isOnAllocation,
  weightPerTruckload: warehouseArea.weightPerTruckload,
  leadTimeDisplayUnits: warehouseArea.leadTimeDisplayUnits,
  leadTimeInDays: warehouseArea.leadTimeInDays,
  minOrderQuantity: warehouseArea.minOrderQuantity,
})
